import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import SelecaoColaboradores, { selecaoColaboradoresVazia, SelecaoColaboradoresValor } from '../components/SelecaoColaboradores'

interface ResultadoItem {
  motcod: string
  motnome: string
  status: 'ok' | 'sem_ficha' | 'bloqueada' | 'erro'
  erro?: string
}

const LABEL_STATUS: Record<ResultadoItem['status'], string> = {
  ok: 'Excluída', sem_ficha: 'Sem ficha nesse período', bloqueada: 'Bloqueada', erro: 'Erro',
}

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export default function ExcluirFichasLote() {
  const navigate = useNavigate()
  const [selecao, setSelecao] = useState<SelecaoColaboradoresValor>(selecaoColaboradoresVazia())
  const [ano, setAno] = useState(new Date().getFullYear())
  const [mes, setMes] = useState(new Date().getMonth() + 1)
  const [erro, setErro] = useState('')
  const [excluindo, setExcluindo] = useState(false)
  const [resultados, setResultados] = useState<ResultadoItem[] | null>(null)

  async function excluir() {
    if (selecao.modo === 'individual' && !selecao.colaboradorCodigo) { setErro('Selecione um colaborador.'); return }
    if (selecao.modo === 'categoria' && selecao.catcat.length === 0) { setErro('Selecione ao menos uma categoria de cargo.'); return }
    if (!window.confirm(
      `Excluir as fichas ponto de ${MESES[mes - 1]}/${ano} dos colaboradores selecionados? ` +
      'Isso remove todos os dias lançados em cada uma e não pode ser desfeito.',
    )) return

    setExcluindo(true)
    setErro('')
    setResultados(null)
    try {
      const r = await api.post('/cartao-ponto/fichas/excluir-lote', {
        modo: selecao.modo, catcat: selecao.catcat, colaborador: selecao.colaboradorCodigo,
        excluidos: selecao.excluidos,
        ano, mes,
      })
      setResultados(r.data.resultados)
    } catch (e: any) {
      setErro(e.response?.data?.error ?? 'Erro ao excluir as fichas.')
    } finally {
      setExcluindo(false)
    }
  }

  return (
    <div style={{ maxWidth: 900 }}>
      <div className="card">
        <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.4rem' }}>Excluir Fichas em Lote</h3>
        <p style={{ color: '#6b7280', fontSize: '0.85rem', marginTop: 0, marginBottom: '1rem' }}>
          Remove a ficha e todos os dias lançados dos colaboradores selecionados, no ano/mês informado.
          Fichas fechadas que travam o banco de horas de um fechamento posterior são puladas (veja o motivo no resultado).
        </p>

        <SelecaoColaboradores valor={selecao} onChange={setSelecao} />

        <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginTop: '1.2rem' }}>
          <div className="field">
            <label>Ano da ficha *</label>
            <input type="number" value={ano} onChange={e => setAno(Number(e.target.value))} />
          </div>
          <div className="field">
            <label>Mês da ficha *</label>
            <select value={mes} onChange={e => setMes(Number(e.target.value))}>
              {MESES.map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
            </select>
          </div>
        </div>

        {erro && <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginTop: '0.5rem' }}>{erro}</div>}

        {resultados && (
          <div style={{ marginTop: '1rem', overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>
                  <th style={{ padding: '4px 8px' }}>Colaborador</th>
                  <th style={{ padding: '4px 8px' }}>Situação</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map(r => (
                  <tr key={r.motcod} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '4px 8px' }}>{r.motcod} - {r.motnome}</td>
                    <td style={{ padding: '4px 8px', color: r.status === 'ok' ? '#15803d' : (r.status === 'erro' || r.status === 'bloqueada') ? '#b91c1c' : '#6b7280' }}>
                      {LABEL_STATUS[r.status]}{r.erro ? `: ${r.erro}` : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: '1rem' }}>
          <button className="btn btn-danger" onClick={excluir} disabled={excluindo}>
            {excluindo ? 'Excluindo...' : 'Excluir Fichas'}
          </button>
          <button className="btn btn-outline" onClick={() => navigate('/funcionarios/ficha-ponto')}>Voltar</button>
        </div>
      </div>
    </div>
  )
}
